/**
 * PROPRIETARY AND CONFIDENTIAL
 * Copyright © 2026 Contractor Co-Pilot. All Rights Reserved.
 */

"use client";

import { SolutionTemplate } from "@/components/landing/solution-template";
import { hvacConfig } from "./hvac-config";

export function HvacSolutionsPageClient() {
  return <SolutionTemplate config={hvacConfig} />;
}
